const PERMISSION_KEY= "personalize:nebula_performance";
const PAGE_URL = {
    NEBULA_PERFORMANCE_PAGE: "/admin/personalize/nebula-performance"
}

export {PERMISSION_KEY, PAGE_URL}

